import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/user';
import 金融機関借入 from '@/entries/user/pages/authorized/事業所/計画書/分析計画/借入/金融機関借入/金融機関借入.vue';
import 役員借入 from '@/entries/user/pages/authorized/事業所/計画書/分析計画/借入/役員借入/役員借入.vue';
import 返済計画 from '@/entries/user/pages/authorized/事業所/計画書/計画/借入返済/返済計画/返済計画.vue';
import 返済明細 from '@/entries/user/pages/authorized/事業所/計画書/計画/借入返済/返済明細/返済明細.vue';

import MoneyUnitSelect from '@/components/moneyUnitSelect/MoneyUnitSelect.vue';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import TabsMixin from '@/mixins/TabsMixin';

export default mixins(RoutesMixin, TabsMixin).extend({
  name: 'P借入返済',

  components: {
    tab0: 金融機関借入,
    tab1: 役員借入,
    tab2: 返済計画,
    tab3: 返済明細,
    MoneyUnitSelect,
  },

  data(): {
    tabs: string[];
    eフェーズ種別: Eフェーズ種別;
  } {
    return {
      tabs: ['金融機関借入', '役員借入', '返済計画', '返済明細'],
      eフェーズ種別: Eフェーズ種別.計画フェーズ,
    };
  },
});
